import React from 'react'
import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

const NotFoundPage = () => {
  return (
    <div className="text-center py-20">
      <div className="text-6xl font-bold text-gray-300 mb-4">404</div>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">页面未找到</h1>
      <p className="text-gray-600 mb-8">抱歉，您访问的页面不存在</p>
      <Link to="/" className="btn-primary inline-flex items-center">
        <Home size={18} className="mr-2" />
        返回首页
      </Link>
    </div>
  )
}

export default NotFoundPage
